import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberSettingsPage from "@/pages/member/MemberSettingsPage";

export const Route = createFileRoute("/member/settings")({
  head: () => pageHead("Member · Settings", "AKIVA member · settings portal.", "/member/settings", true),
  component: MemberSettingsPage,
});
